export default __webpack_public_path__ + "static/media/uber-pickup.inline.cb1f5916.svg";